var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32087 11.814L19.3209 0.814026M8.32087 11.814L11.8209 18.814C11.8647 18.9098 11.9352 18.9909 12.0238 19.0478C12.1125 19.1047 12.2156 19.1349 12.3209 19.1349C12.4262 19.1349 12.5293 19.1047 12.6179 19.0478C12.7066 18.9909 12.777 18.9098 12.8209 18.814L19.3209 0.814026M8.32087 11.814L1.32087 8.31403C1.22513 8.27015 1.144 8.19971 1.08712 8.11108C1.03024 8.02244 1 7.91934 1 7.81403C1 7.70871 1.03024 7.60561 1.08712 7.51697C1.144 7.42834 1.22513 7.3579 1.32087 7.31403L19.3209 0.814026",
    stroke: "#8C8D96",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/sent-icon.cff091257275c3b815f87751346d733e.svg";
export { ForwardRef as ReactComponent };